var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowLoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64616 0.739258C6.7771 0.739258 4.42969 3.08667 4.42969 5.95573C4.42969 8.82479 9.64616 15.5193 9.64616 15.5193C9.64616 15.5193 14.8626 8.82479 14.8626 5.95573C14.8626 3.08667 12.5152 0.739258 9.64616 0.739258ZM9.64616 7.69456C8.68981 7.69456 7.90734 6.91208 7.90734 5.95573C7.90734 4.99938 8.68981 4.21691 9.64616 4.21691C10.6025 4.21691 11.385 4.99938 11.385 5.95573C11.385 6.91208 10.6025 7.69456 9.64616 7.69456Z",
    fill: "#FFEB33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1226 10.3897C14.8618 10.9113 14.6009 11.433 14.2532 11.9546C15.7312 12.4763 16.6006 13.1718 16.6006 13.7804C16.6006 14.8237 13.8185 16.3886 9.64529 16.3886C5.47212 16.3886 2.69 14.8237 2.69 13.7804C2.69 13.1718 3.55941 12.4763 5.03741 11.8677C4.68964 11.346 4.42882 10.8244 4.168 10.3027C2.16835 11.1721 0.951172 12.3893 0.951172 13.7804C0.951172 16.2147 4.6027 18.1274 9.47141 18.1274C13.8185 18.1274 18.3394 16.6494 18.3394 13.7804C18.3394 12.3893 17.1222 11.1721 15.1226 10.3897Z",
    fill: "#FFEB33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLoc);
export default __webpack_public_path__ + "static/media/yellowLoc.22dad6ad91c53183f158994f7f53e5d6.svg";
export { ForwardRef as ReactComponent };